import { useContext, useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router';
import ActivityElements from './ActivityElements';
import BioElements from './BioElements';
import ProfileImage from './ProfileImage';
import { store } from 'components/Store';
import CustomScrollbar from 'components/Common/CustomScrollbar';
import EmployersElement from 'components/Dashboard/StakeHolders/StakeholderPage/ui/EmployersElement';

const MobileUI = (props) => {
  const { ScrollContent, StakeholderInformation, clickOnSeeMore, isInitialActivityLoading, isLoadingActivity } = props;

  const globalState = useContext(store);
  const { state, dispatch } = globalState;
  const { stakeholderMobileSection } = state;

  const scrollBarRef = useRef(null);
  const params = useParams();
  const { contentType } = params;
  const [activeSection, setActiveSection] = useState(
    contentType || clickOnSeeMore || stakeholderMobileSection === 'activity' ? 'activity' : 'profile'
  );

  const { isStaff, employers } = StakeholderInformation ?? {};

  const changeSection = (section) => {
    setActiveSection(section);
    scrollBarRef.current.scrollTop();
  };
  const topElements = useRef(null);

  useEffect(() => {
    return () =>
      dispatch({
        type: 'MODIFY_SECTION',
        parameter: 'stakeholderMobileSection',
        value: '',
      });
  }, []);

  const sections = ['Profile', isStaff ? 'Employers' : 'Activity'];

  return (
    <div className='bg-white dashboard-root-container'>
      <div ref={topElements}>
        <ProfileImage StakeholderInformation={StakeholderInformation} />
        <div className='mobile-stakeholder-buttons border-bottom d-flex'>
          {sections?.map((item) => {
            const key = item.toLowerCase();
            return (
              <button
                key={key}
                className={`general-button stakeholder-section-button flex-grow-1 ${activeSection === key ? 'active' : ''}`}
                onClick={() => {
                  changeSection(key);
                }}
              >
                {item}
              </button>
            );
          })}
        </div>
      </div>
      <div className='flex-grow-1'>
        <CustomScrollbar
          className={'simple-scrollbar'}
          maximalThumbYSize={100}
          onScroll={(scrollValues) => {
            ScrollContent(scrollValues);
          }}
          ref={scrollBarRef}
        >
          <div className='mobile-stakeholders-container'>
            {activeSection === 'profile' && <BioElements {...props} />}
            {activeSection === 'activity' && (
              <ActivityElements
                scrollBarRef={scrollBarRef}
                {...props}
                isLoadingActivity={isLoadingActivity || isInitialActivityLoading}
              />
            )}
            {activeSection === 'employers' && <EmployersElement employers={employers} />}
          </div>
        </CustomScrollbar>
      </div>
    </div>
  );
};

export default MobileUI;
